// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';


// CUSTOM 
import InputField from '../../../components/formFields/InputField';
import TextAreaField from '../../../components/formFields/TextAreaField';





export const CreateTipoCotizacionForm = (props:any) => {



    const { formField: {
        name,
        description
      }
    } = props;


            


    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
    }));


    
    
  return (
    <div>
        
        <div>
            <Grid container>

                <Grid size={{ xs: 12}} sx={{ padding: 2 }}>
                    <InputField
                        name={name.name}
                        label={name.label}
                        variant="outlined" 
                        fullWidth
                    />
                </Grid>
                
             
                <Grid size={{ xs: 12}} sx={{ padding: 2 }}>
                    <TextAreaField
                        name={description.name}
                        label={description.label}
                        variant="outlined"
                        autoComplete="off"  
                        fullWidth
                    />
                </Grid>
                
                    

            </Grid>
        </div>
        
    </div>
  )
}

